import React, { useEffect } from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";
import ImageCarousal from "../ImageCarousal";
import { useState } from "react";

const TeamSection = ({ team, Title, subTitle }) => {
  const [startIndex, setStartIndex] = useState(0);

  const [numOfImages, setNumOfImages] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setNumOfImages(1);
      } else {
        setNumOfImages(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const clickHandler = () => {
    const nextIndex = startIndex + numOfImages;
    if (nextIndex < team.length) {
      setStartIndex(nextIndex);
    } else {
      setStartIndex(0);
    }
  };

  const prevHandler = () => {
    const prevIndex = startIndex - numOfImages;
    if (prevIndex >= 0) {
      setStartIndex(prevIndex);
    } else {
      const lastPage =
        Math.floor((team.length - 1) / numOfImages) * numOfImages;
      setStartIndex(lastPage);
    }
  };

  const { leftArrow, rightArrow } = images;

  return (
    <div className={styles.teamContainer}>
      <div className={styles.headingText}>
        <div className={styles.headings}>
          {Title ? <h1 id={styles.title}>{Title}</h1> : ""}
          <h1>{subTitle}</h1>
        </div>
        <div className={styles.arrowButtons}>
          <div onClick={prevHandler} className={styles.arrowButton}>
            <img src={leftArrow} alt="" />
          </div>
          <div
            onClick={clickHandler}
            id={styles.rightArrow}
            className={styles.arrowButton}
          >
            <img src={rightArrow} alt="" />
          </div>
        </div>
      </div>
      <div className={styles.allImages}>
        {team.slice(startIndex, startIndex + numOfImages).map((img, index) => (
          <ImageCarousal img={img} key={index} />
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
